module.exports = __webpack_public_path__ + "img/t3-8.5322a9c3.svg";